import { render, staticRenderFns } from "./illegal.vue?vue&type=template&id=60a4cd48&"
import script from "./illegal.vue?vue&type=script&lang=js&"
export * from "./illegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports